import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const UPDATE_CONFIG = gql`
  mutation UpdateConfig($input: [UpdateMonthsThresholdInput]!) {
    updateConfig(input: $input) {
      message
    }
  }
`;
